import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import googleG from "../../../assets/images/google-g.png";
import loginBg from "../../../assets/images/login-background.png";
import logoRah from "../../../assets/images/logo-rah.png";
import { api } from "../../../utils/axios";
import ResetPass from "./ResetPass";
import VerifyCode from "./VerifyCode";

function ForgotPassword({ user }) {
	const [mobile, setMobile] = useState("");
	const [email, setEmail] = useState("");
	const [code, setCode] = useState("");
	const [mobileIsValid, setMobileIsValid] = useState(true);
	const [emailIsValid, setEmailIsValid] = useState(true);
	const [stage, setStage] = useState(0);
	const [recoverParam, setRecoverParam] = useState("mobile");
	const [data, setData] = useState(null);

	const recoverParamOnChangeHandler = (e, value) => {
		e.preventDefault();
		setRecoverParam(value);
	};

	const mobileOnChangeHandler = (e) => {
		setMobileIsValid(true);
		setMobile(e.target.value);
	};

	const emailOnChangeHandler = (e) => {
		setEmailIsValid(true);
		setEmail(e.target.value);
	};

	const formOnSubmitHandler = (e) => {
		e.preventDefault();

		if (recoverParam === "mobile" && !mobile) {
			setMobileIsValid(false);
			return;
		}

		if (recoverParam === "email" && !email) {
			setMobileIsValid(false);
			return;
		}

		let data = {};
		if (recoverParam === "email") data = { email: email };
		if (recoverParam === "mobile") data = { mobile: mobile };

		api
			.post("/forgot_password", data)
			.then((res) => {
				setStage(1);
				setData(data);
				toast.success(
					recoverParam === mobile
						? "کد تایید به موبایل شما ارسال شد"
						: "کد تایید به ایمیل شما ارسال شد",
				);
			})
			.catch((err) => {
				toast.error(err?.response?.data?.error);
			});
	};

	return (
		<div className={"tw-w-full tw-h-screen login-bg-wrapper"}>
			<img src={loginBg} alt="login background" className="login-bg-img" />
			<div className="login-content-wrapper">
				<div className="login-form-box">
					<div className="login-logo-box">
						<img src={logoRah} alt="logo rah" className="login-logo-img" />
					</div>
					{stage === 0 && (
						<>
							<h2 className="login-title">فراموشی رمز عبور</h2>
							<form className="login-form" onSubmit={formOnSubmitHandler}>
								{stage === 0 && (
									<>
										{recoverParam === "mobile" && (
											<div className="form-group">
												<input
													type="text"
													id="mobile"
													name="mobile"
													className="form-control"
													value={mobile}
													onChange={mobileOnChangeHandler}
													autoComplete={"mobile"}
													placeholder="شماره موبایل خود را وارد کنید"
												/>
												{!mobileIsValid && (
													<div className={"form-helper text-danger mb-3 px-2"}>
														شماره وارد شده نامعتبر است
													</div>
												)}
											</div>
										)}
										{recoverParam === "email" && (
											<div className="form-group">
												<input
													type={"email"}
													id="email"
													name="email"
													className="form-control"
													value={email}
													onChange={emailOnChangeHandler}
													autoComplete={"email"}
													placeholder="ایمیل خود را وارد کنید"
												/>
												{!emailIsValid && (
													<div className={"form-helper text-danger mb-3 px-2"}>
														ایمیل وارد شده نامعتبر است
													</div>
												)}
											</div>
										)}
									</>
								)}
								{stage === 0 && (
									<div className="tw-text-sm tw-px-3 tw-w-fit">
										{recoverParam === "email" && (
											<button
												onClick={(e) =>
													recoverParamOnChangeHandler(e, "mobile")
												}
												className="form-group"
											>
												بازنشانی با شماره همراه
											</button>
										)}

										{recoverParam === "mobile" && (
											<button
												onClick={(e) => recoverParamOnChangeHandler(e, "email")}
												className="form-group"
											>
												بازنشانی با ایمیل
											</button>
										)}
									</div>
								)}
								<div className="form-btn-group">
									<button type="submit" className="btn btn-primary">
										{stage === 0 ? " ارسال کد" : "تایید"}
									</button>
								</div>
							</form>
						</>
					)}
					{stage === 1 && (
						<VerifyCode data={data} setStage={setStage} setData={setData} />
					)}
					{stage === 2 && <ResetPass data={data} />}
				</div>
			</div>
		</div>
	);
}
export default ForgotPassword;
